// Graph Database Type Definitions
// Based on jnana-serverless graph types

export enum NodeTypeId {
  BHAJAN = 1,
  LYRICS = 2,
  RAGAM = 3,
  TALAM = 4,
  COMPOSER = 5,
  DEITY = 6,
  ALBUM = 7,
  TRACK = 8,
  AUDIBLE = 9,
  MEANING = 10,
  COMPOSITION_LANGUAGE = 11,
  BHAJAN_BABIES = 12,
  RASHI = 13,
  STAR = 14,
  BODY_PART = 15,
  CHAKRA = 16,
  ELEMENT = 17,
  GEM = 18,
  COLOR = 19,
  TREE = 20,
  COLLECTION = 21,
  PLACE = 22,
  THITHI = 23,
  CONCERT_TRACK = 24,
  CONCERT = 25,
  PITCH = 26,
  BHAJAN_FACT = 27,
  WESTERN_NOTES = 28,
}

export const NodeTypeNames: Record<NodeTypeId, string> = {
  [NodeTypeId.BHAJAN]: 'Bhajan',
  [NodeTypeId.LYRICS]: 'Lyrics',
  [NodeTypeId.RAGAM]: 'Ragam',
  [NodeTypeId.TALAM]: 'Talam',
  [NodeTypeId.COMPOSER]: 'Composer',
  [NodeTypeId.DEITY]: 'Deity',
  [NodeTypeId.ALBUM]: 'Album',
  [NodeTypeId.TRACK]: 'Track',
  [NodeTypeId.AUDIBLE]: 'Audible',
  [NodeTypeId.MEANING]: 'Meaning',
  [NodeTypeId.COMPOSITION_LANGUAGE]: 'Composition Language',
  [NodeTypeId.BHAJAN_BABIES]: 'Bhajan Babies',
  [NodeTypeId.RASHI]: 'Rashi',
  [NodeTypeId.STAR]: 'Star',
  [NodeTypeId.BODY_PART]: 'Body Part',
  [NodeTypeId.CHAKRA]: 'Chakra',
  [NodeTypeId.ELEMENT]: 'Element',
  [NodeTypeId.GEM]: 'Gem',
  [NodeTypeId.COLOR]: 'Color',
  [NodeTypeId.TREE]: 'Tree',
  [NodeTypeId.COLLECTION]: 'Collection',
  [NodeTypeId.PLACE]: 'Place',
  [NodeTypeId.THITHI]: 'Thithi',
  [NodeTypeId.CONCERT_TRACK]: 'Concert Track',
  [NodeTypeId.CONCERT]: 'Concert',
  [NodeTypeId.PITCH]: 'Pitch',
  [NodeTypeId.BHAJAN_FACT]: 'Bhajan Fact',
  [NodeTypeId.WESTERN_NOTES]: 'Western Notes',
};

export enum GraphDomain {
  BhajanMala = 1,
  RagaSagara = 2,
  SgsSatsang = 4,
  All = 7,
}

export enum Language {
  TE = 'te',
  EN = 'en',
  KN = 'kn',
  TA = 'ta',
  HI = 'hi',
  ML = 'ml',
  OR = 'or',
  BN = 'bn',
  PA = 'pa',
  GU = 'gu',
}

export enum EdgeCardinality {
  Single = 'single',
  Multi = 'multi',
}

/**
 * Loose graph node shape for code that hasn't been migrated yet to the
 * discriminated union in `./graphNodes.ts`. New code should use AnyGraphNode
 * + type guards instead of GraphDataNode.
 *
 * Edges canonicalized to the array form returned by our serverless API
 * (jnana-admin used a Record<string, number|number[]>; we normalize at
 * the edge-filter layer in src/filters/definitions/edgeFilter.ts).
 */
export interface GraphDataNode {
  nodeId: number;
  nodeTypeId: NodeTypeId;
  data: Record<string, unknown>;
  edges: Array<{ name: string; nodeId: number }>;
  domain?: GraphDomain | number;
  domains?: number;
  createdAt?: string | number;
  updatedAt?: string | number;
  /** Server-stamped node flag; see BaseNode.hasSvaras in ./graphNodes.ts. */
  hasSvaras?: boolean;
}
